import { render } from "./Framelink.vue?vue&type=template&id=2402e840"
import script from "./Framelink.vue?vue&type=script&lang=js"
export * from "./Framelink.vue?vue&type=script&lang=js"

import "./Framelink.vue?vue&type=style&index=0&id=2402e840&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__